<template>
  <div id="cajaChica">
    <v-flex xs12 sm12 md6>
      <v-select v-model="caja_chica" :items="catalogos.cajas_chicas" item-text="descripcion" item-value="id"
        label="Seleccionar caja chica"></v-select>
    </v-flex>
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Movimientos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-title>Importe Actual: $ {{ total || 0.0 }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="newRequest()">
            <v-icon>note_add</v-icon>
          </v-btn>
          <span>Nueva Caja chica</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" :disabled="moves.length == 0" icon @click="detailRequest()">
            <v-icon>description</v-icon>
          </v-btn>
          <span>Ver detalle Caja chica</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading"
            :disabled="moves.length == 0 || moves[moves.length - 1].estado != 'Enviado'" icon
            @click="dialogNewInc = true">
            <v-icon>trending_up</v-icon>
          </v-btn>
          <span>Incrementar Caja chica</span>
        </v-tooltip>
        <!--<v-tooltip top>
          <v-btn slot="activator" :loading="loading" :disabled="moves.length == 0" icon @click="questionCan = true">
            <v-icon>delete_forever</v-icon>
          </v-btn>
          <span>Cancelar Caja chica</span>
        </v-tooltip>-->
        <v-dialog v-model="dialogNewReq" fullscreen hide-overlay :persistent="true"
          transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dense dark color="blue-grey">
              <v-btn icon dark :disabled="loading" @click="close()">
                <v-icon>close</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-toolbar-title>Solicitud de fondo fijo de caja</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark flat :loading="loading" @click="questionReq = true">Guardar</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-container>
                      <h3 class="grey--text">GENERAL</h3><br />
                      <v-radio-group v-model="solicitud.area" :error-messages="areaErrors" :mandatory="false"
                        @input="$v.solicitud.area.$touch()" @blur="$v.solicitud.area.$touch()">
                        <div slot="label"><strong>Área</strong></div>
                        <v-radio label="Oficinas administrativas" color="primary"
                          value="oficinas_administrativas"></v-radio>
                        <v-radio label="Oficinas comerciales" color="primary" value="oficinas_comerciales"></v-radio>
                      </v-radio-group>
                      <br />
                      <h3 class="grey--text">RESPONSABLE</h3><br />
                      <v-text-field v-model="solicitud.nombre" :error-messages="nombreErrors" label="Nombre"
                        @input="$v.solicitud.nombre.$touch()" @blur="$v.solicitud.nombre.$touch()" box
                        readonly></v-text-field>
                      <v-text-field v-model="solicitud.puesto" :error-messages="puestoErrors" label="Puesto"
                        @input="$v.solicitud.puesto.$touch()" @blur="$v.solicitud.puesto.$touch()" box
                        readonly></v-text-field>
                      <v-text-field v-model="solicitud.departamento" :error-messages="departamentoErrors"
                        @input="$v.solicitud.departamento.$touch()" @blur="$v.solicitud.departamento.$touch()"
                        label="Departamento" box readonly></v-text-field>
                      <v-text-field v-model="solicitud.oficina" :error-messages="oficinaErrors" label="Oficina"
                        @input="$v.solicitud.oficina.$touch()" @blur="$v.solicitud.oficina.$touch()" box
                        readonly></v-text-field>
                      <v-select v-model="solicitud.centro" :error-messages="centroErrors" :items="catalogos.centros"
                        @input="$v.solicitud.centro.$touch()" @blur="$v.solicitud.centro.$touch()"
                        item-text="descripcion" item-value="id" label="Centro de costos"></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-container>
                      <h3 class="grey--text">FONDO FIJO</h3><br />
                      <v-text-field v-model.lazy="solicitud.importe" :error-messages="importeErrors" label="Importe"
                        @input="$v.solicitud.importe.$touch()" @blur="$v.solicitud.importe.$touch()" prefix="$"
                        suffix="MXN"></v-text-field>
                      <v-text-field v-model="solicitud.letra" :error-messages="letraErrors" :value="importeLetra"
                        @input="$v.solicitud.letra.$touch()" @blur="$v.solicitud.letra.$touch()"
                        label="Importe con letra"></v-text-field>
                      <v-select v-model="solicitud.detalle" :error-messages="detalleErrors" :items="catalogos.detalles"
                        @input="$v.solicitud.detalle.$touch()" @blur="$v.solicitud.detalle.$touch()"
                        item-text="descripcion" item-value="id" label="Detalle" box readonly></v-select>
                      <v-select v-model="solicitud.empresa" :error-messages="empresaErrors" :items="catalogos.empresas"
                        @input="$v.solicitud.empresa.$touch()" @blur="$v.solicitud.empresa.$touch()"
                        item-text="descripcion" item-value="id" label="Empresa"></v-select>
                      <v-text-field v-model="solicitud.observaciones" :error-messages="observacionesErrors"
                        @input="$v.solicitud.observaciones.$touch()" @blur="$v.solicitud.observaciones.$touch()"
                        label="Observaciones"></v-text-field>
                      <br />
                      <h3 class="grey--text">DOCUMENTOS</h3><br />
                      <v-layout v-if="dialogNewReq" wrap>
                        <v-flex xs12 sm12 md6>
                          <v-btn block :loading="loading" round :color="color.pagare" @click="$refs.pagare.click()">
                            Pagaré
                            <v-icon right dark>attach_file</v-icon>
                          </v-btn>
                          <input v-show="false" ref="pagare" type="file" @change="readFile('pagare')">
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-btn block :loading="loading" round :color="color.responsiva"
                            @click="$refs.responsiva.click()">
                            Carta responsiva
                            <v-icon right dark>attach_file</v-icon>
                          </v-btn>
                          <input v-show="false" ref="responsiva" type="file" @change="readFile('responsiva')">
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="questionReq" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">¿Desea guardar la caja chica?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click.native="questionReq = false">Cancelar</v-btn>
              <v-btn flat color="orange" @click.native="save()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDetReq" fullscreen hide-overlay :persistent="true"
          transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dense dark color="blue-grey">
              <v-btn icon dark :disabled="loading" @click="close()">
                <v-icon>close</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-toolbar-title>Detalle de fondo fijo de caja</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-tooltip left>
                  <v-btn slot="activator" :loading="loading" icon @click="print()">
                    <v-icon>local_printshop</v-icon>
                  </v-btn>
                  <span>Imprimir</span>
                </v-tooltip>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6>
                    <v-container fluid>
                      <h3 class="grey--text">GENERAL</h3><br />
                      <v-radio-group v-model="detalle.area" :mandatory="false" disabled>
                        <div slot="label"><strong>Área</strong></div>
                        <v-radio label="Oficinas administrativas" color="primary"
                          value="oficinas_administrativas"></v-radio>
                        <v-radio label="Oficinas comerciales" color="primary" value="oficinas_comerciales"></v-radio>
                      </v-radio-group>
                      <br />
                      <h3 class="grey--text">RESPONSABLE</h3><br />
                      <v-text-field v-model="detalle.nombre" label="Nombre" disabled></v-text-field>
                      <v-text-field v-model="detalle.puesto" label="Puesto" disabled></v-text-field>
                      <v-text-field v-model="detalle.departamento" label="Departamento" disabled></v-text-field>
                      <v-text-field v-model="detalle.oficina" label="Oficina" disabled></v-text-field>
                      <v-text-field v-model="detalle.centro" label="Centro de costos" disabled></v-text-field>
                      <br />
                      <h3 class="grey--text">FIRMAS</h3><br />
                      <v-list three-line dark>
                        <template v-for="(item, i) in detalle.firmas">
                          <v-list-tile class="pb-2 pt-2">
                            <v-list-tile-content>
                              <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                              <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                              <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                              <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                                v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider v-show="(i + 1) < detalle.firmas.length"></v-divider>
                        </template>
                      </v-list>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-container fluid>
                      <h3 class="grey--text">FONDO FIJO</h3><br />
                      <v-text-field v-model.lazy="detalle.importe" label="Importe" prefix="$" suffix="MXN"
                        disabled></v-text-field>
                      <v-text-field v-model="detalle.letra" label="Importe con letra" disabled></v-text-field>
                      <v-text-field v-model="detalle.detalle" label="Detalle" disabled></v-text-field>
                      <v-text-field v-model="detalle.empresa" label="Empresa" disabled></v-text-field>
                      <v-text-field v-model="detalle.observaciones" label="Observaciones" disabled></v-text-field>
                      <br />
                      <h3 class="grey--text">DOCUMENTOS</h3><br />
                      <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                          <v-btn block :loading="loading" color="blue-grey" class="white--text"
                            @click="downloadData('pagare')">
                            Pagaré
                            <v-icon right dark>cloud_download</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-btn block :loading="loading" color="blue-grey" class="white--text"
                            @click="downloadData('responsiva')">
                            Carta responsiva
                            <v-icon right dark>cloud_download</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogNewInc" persistent width="500">
          <v-card>
            <v-toolbar dense dark color="blue-grey">
              <v-toolbar-title>Solicitud de incremento de caja</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-text-field v-model.lazy="solicitud.importe" :error-messages="importeErrors" label="Nuevo Importe"
                  @input="$v.solicitud.importe.$touch()" @blur="$v.solicitud.importe.$touch()" prefix="$"
                  suffix="MXN"></v-text-field><br />
                <v-text-field v-model="solicitud.letra" :error-messages="letraErrors"
                  @input="$v.solicitud.letra.$touch()" @blur="$v.solicitud.letra.$touch()"
                  label="Importe con letra"></v-text-field><br />
                <v-text-field v-model="solicitud.observaciones" :error-messages="observacionesErrors"
                  @input="$v.solicitud.observaciones.$touch()" @blur="$v.solicitud.observaciones.$touch()"
                  label="Observaciones"></v-text-field><br />
                <h3 class="grey--text">DOCUMENTOS</h3><br />
                <v-layout v-if="dialogNewInc" wrap>
                  <v-flex xs12 sm12 md6>
                    <v-btn block round :color="color.pagare" @click="$refs.pagare.click()">
                      Pagaré
                      <v-icon right dark>attach_file</v-icon>
                    </v-btn>
                    <input v-show="false" ref="pagare" type="file" @change="readFileInc('pagare')">
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-btn block round :color="color.responsiva" @click="$refs.responsiva.click()">
                      Carta responsiva
                      <v-icon right dark>attach_file</v-icon>
                    </v-btn>
                    <input v-show="false" ref="responsiva" type="file" @change="readFileInc('responsiva')">
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat v-show="!loading" color="blue-grey" @click.native="close()">Cancelar</v-btn>
              <v-btn dark color="blue-grey" :loading="loading" @click.native="newIncrease()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDetInc" persistent width="500">
          <v-card>
            <v-toolbar dense dark color="blue-grey">
              <v-spacer></v-spacer>
              <v-toolbar-title>Detalle de incremento de caja</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <h3 class="grey--text">GENERAL</h3><br />
                <v-text-field v-model="detalle.incremento.importe" label="Nuevo Importe" prefix="$" suffix="MXN"
                  disabled></v-text-field><br />
                <v-text-field v-model="detalle.incremento.letra" label="Importe con letra"
                  disabled></v-text-field><br />
                <v-text-field v-model="detalle.incremento.observaciones" label="Observaciones"
                  disabled></v-text-field><br />
                <h3 class="grey--text">DOCUMENTOS</h3><br />
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-btn block flat :loading="loading" color="blue-grey" class="white--text"
                      @click="downloadDataInc('pagare')">
                      Pagaré
                      <v-icon right dark>cloud_download</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-btn block flat :loading="loading" color="blue-grey" class="white--text"
                      @click="downloadDataInc('responsiva')">
                      Carta responsiva
                      <v-icon right dark>cloud_download</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout><br />
                <h3 class="grey--text">FIRMAS</h3><br />
                <v-list three-line dark>
                  <template v-for="(item, i) in detalle.incremento.firmas">
                    <v-list-tile class="pb-2 pt-2">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                        <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                          v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-show="(i + 1) < detalle.incremento.firmas.length"></v-divider>
                  </template>
                </v-list>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="blue-grey" @click.native="close()">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="questionCan" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">¿Desea cancelar la solicitud?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click.native="questionCan = false">Cancelar</v-btn>
              <v-btn flat color="error" @click.native="cancelRequest()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details
          maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="moves" :loading="loading" :search="search"
        rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetailInc(props.item.id)">{{ props.item.id_seg }}</td>
          <td class="text-xs-center" @click="showDetailInc(props.item.id)">{{ props.item.tipo }}</td>
          <td class="text-xs-center" @click="showDetailInc(props.item.id)">{{ props.item.estado }}</td>
          <td class="text-xs-center" @click="showDetailInc(props.item.id)">$ {{
            props.item.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetailInc(props.item.id)">{{ props.item.fecha_registro }}</td>
          <td class="text-xs-center" @click="showDetailInc(props.item.id)">{{ props.item.fecha_actualizacion }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import numeroALetras from '@/assets/js/NumeroALetras.js'
import services from '@/config/services'
import axios from 'axios'
import download from 'downloadjs'
import { validationMixin } from 'vuelidate'
import { decimal, maxLength, maxValue, minValue, required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'cajaChica',
  mixins: [validationMixin],
  validations: {
    solicitud: {
      area: { required: requiredIf(function () { return this.isNewReq }) },
      nombre: { required: requiredIf(function () { return this.isNewReq }) },
      puesto: { required: requiredIf(function () { return this.isNewReq }) },
      departamento: { required: requiredIf(function () { return this.isNewReq }) },
      oficina: { required: requiredIf(function () { return this.isNewReq }) },
      centro: { required: requiredIf(function () { return this.isNewReq }) },
      importe: { required, decimal, minValue: minValue(0.01), maxValue: maxValue(999999.99) },
      letra: { required, maxLength: maxLength(200) },
      detalle: { required: requiredIf(function () { return this.isNewReq }) },
      empresa: { required: requiredIf(function () { return this.isNewReq }) },
      observaciones: { required, maxLength: maxLength(300) }
    }
  },
  data: () => ({
    loading: false,
    success: false,
    error: false,
    msgSuccess: '',
    msgError: '',
    dialogNewReq: false,
    dialogDetReq: false,
    dialogNewInc: false,
    dialogDetInc: false,
    questionReq: false,
    questionCan: false,
    search: '',
    pagination: {
      rowsPerPage: 7
    },
    headers: [
      { text: "Id", align: "center", sortable: false, value: "id_seg" },
      { text: 'Tipo', align: 'center', sortable: false, value: 'tipo' },
      { text: 'Estado', align: 'center', sortable: false, value: 'estado' },
      { text: 'Importe', align: 'center', sortable: false, value: 'importe' },
      { text: 'Fecha de Registro', align: 'center', sortable: false, value: 'fecha_registro' },
      { text: 'Fecha de Actualización', align: 'center', sortable: false, value: 'fecha_actualizacion' }
    ],
    moves: [],
    total: null,
    catalogos: {
      empresas: [],
      centros: [],
      detalles: [],
      cajas_chicas: []
    },
    color: {
      pagare: '',
      responsiva: ''
    },
    caja_chica: null,
    solicitud: {
      area: null,
      nombre: '',
      puesto: '',
      departamento: '',
      oficina: '',
      centro: '',
      importe: '',
      letra: '',
      detalle: '',
      empresa: '',
      observaciones: '',
      pagare: { nombre: '', data: null },
      responsiva: { nombre: '', data: null },
      incremento: {
        pagare: { nombre: '', data: null },
        responsiva: { nombre: '', data: null }
      }
    },
    detalle: {
      estado: '',
      area: null,
      nombre: '',
      puesto: '',
      departamento: '',
      oficina: '',
      centro: '',
      importe: '',
      letra: '',
      detalle: '',
      empresa: '',
      observaciones: '',
      firmas: [],
      pagare: { nombre: '', data: null },
      responsiva: { nombre: '', data: null },
      incremento: {
        id: '',
        importe: '',
        letra: '',
        observaciones: '',
        pagare: { nombre: '', data: null },
        responsiva: { nombre: '', data: null },
        firmas: []
      }
    },
    idElementoSeleccionado: null
  }),
  watch: {
    'caja_chica'(val) {
      if (val) {
        this.refresh()
      }
    }
  },
  mounted() {
    this.loading = true
    this.ws('get', 'detalleUsuario')
      .then(res => {
        if (res.ok) {
          this.catalogos.cajas_chicas = res.data.catalogos.cajas_chicas
        }
        else {
          this.error = true
          this.msgError = res.message
        }
      })
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    areaErrors() {
      const errors = []
      if (!this.$v.solicitud.area.$dirty) return errors
      !this.$v.solicitud.area.required && errors.push('El campo es obligatorio')
      return errors
    },
    nombreErrors() {
      const errors = []
      if (!this.$v.solicitud.nombre.$dirty) return errors
      !this.$v.solicitud.nombre.required && errors.push('El campo es obligatorio')
      return errors
    },
    puestoErrors() {
      const errors = []
      if (!this.$v.solicitud.puesto.$dirty) return errors
      !this.$v.solicitud.puesto.required && errors.push('El campo es obligatorio')
      return errors
    },
    departamentoErrors() {
      const errors = []
      if (!this.$v.solicitud.departamento.$dirty) return errors
      !this.$v.solicitud.departamento.required && errors.push('El campo es obligatorio')
      return errors
    },
    oficinaErrors() {
      const errors = []
      if (!this.$v.solicitud.oficina.$dirty) return errors
      !this.$v.solicitud.oficina.required && errors.push('El campo es obligatorio')
      return errors
    },
    centroErrors() {
      const errors = []
      if (!this.$v.solicitud.centro.$dirty) return errors
      !this.$v.solicitud.centro.required && errors.push('El campo es obligatorio')
      return errors
    },
    importeErrors() {
      const errors = []
      if (!this.$v.solicitud.importe.$dirty) return errors
      !this.$v.solicitud.importe.decimal && errors.push('El campo es inválido')
      !this.$v.solicitud.importe.minValue && errors.push('El campo no alcanza el valor mínimo')
      !this.$v.solicitud.importe.maxValue && errors.push('El campo excede el valor máximo')
      !this.$v.solicitud.importe.required && errors.push('El campo es obligatorio')
      return errors
    },
    letraErrors() {
      const errors = []
      if (!this.$v.solicitud.letra.$dirty) return errors
      !this.$v.solicitud.letra.maxLength && errors.push('El campo excede la longitud máxima')
      !this.$v.solicitud.letra.required && errors.push('El campo es obligatorio')
      return errors
    },
    detalleErrors() {
      const errors = []
      if (!this.$v.solicitud.detalle.$dirty) return errors
      !this.$v.solicitud.detalle.required && errors.push('El campo es obligatorio')
      return errors
    },
    empresaErrors() {
      const errors = []
      if (!this.$v.solicitud.empresa.$dirty) return errors
      !this.$v.solicitud.empresa.required && errors.push('El campo es obligatorio')
      return errors
    },
    observacionesErrors() {
      const errors = []
      if (!this.$v.solicitud.observaciones.$dirty) return errors
      !this.$v.solicitud.observaciones.maxLength && errors.push('El campo excede la longitud máxima')
      !this.$v.solicitud.observaciones.required && errors.push('El campo es obligatorio')
      return errors
    },
    importeLetra() {
      if (this.solicitud.importe !== '') {
        this.solicitud.letra = numeroALetras(this.solicitud.importe, {
          plural: 'PESOS',
          singular: 'PESO',
          centPlural: 'CENTAVOS',
          centSingular: 'CENTAVO'
        })
      }
      else {
        this.solicitud.letra = ''
      }
    },
    isNewReq() {
      return this.dialogNewReq
    },
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    refresh() {
      let id = this.caja_chica
      if (id) {
        this.loading = true
        this.ws('get', 'movimientosCajaChica', { id })
          .then(res => {
            if (res.ok) {
              this.moves = res.data.movimientos
              this.total = res.data.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            else {
              this.moves = []
              this.total = null
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    prepareForm(data) {
      this.solicitud.nombre = data.detalle.nombre + ' ' + data.detalle.apellido_paterno + ' ' + data.detalle.apellido_materno
      this.solicitud.nombre = this.solicitud.nombre.trim();
      this.solicitud.puesto = data.detalle.puesto
      this.solicitud.departamento = data.detalle.departamento
      this.solicitud.oficina = data.detalle.ubicacion
      this.catalogos.empresas = data.catalogos.empresas
      this.catalogos.centros = data.catalogos.centros
      this.catalogos.detalles = data.catalogos.detalles
      this.solicitud.detalle = 6
      this.dialogNewReq = true
    },
    newRequest() {
      this.loading = true
      this.ws('get', 'detalleUsuario')
        .then(res => {
          if (res.ok) {
            this.prepareForm(res.data)
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    close() {
      this.$v.$reset()
      this.color = {
        pagare: '',
        responsiva: ''
      }
      this.solicitud = {
        area: null,
        nombre: '',
        puesto: '',
        departamento: '',
        oficina: '',
        centro: '',
        importe: '',
        letra: '',
        detalle: '',
        empresa: '',
        observaciones: '',
        pagare: { nombre: '', data: null },
        responsiva: { nombre: '', data: null },
        incremento: {
          pagare: { nombre: '', data: null },
          responsiva: { nombre: '', data: null }
        }
      }
      this.detalle = {
        estado: '',
        area: null,
        nombre: '',
        puesto: '',
        departamento: '',
        oficina: '',
        centro: '',
        importe: '',
        letra: '',
        detalle: '',
        empresa: '',
        observaciones: '',
        firmas: [],
        pagare: { nombre: '', data: null },
        responsiva: { nombre: '', data: null },
        incremento: {
          id: '',
          importe: '',
          letra: '',
          observaciones: '',
          pagare: { nombre: '', data: null },
          responsiva: { nombre: '', data: null },
          firmas: []
        }
      }
      if (this.$refs.pagare && this.$refs.responsiva) {
        this.$refs.pagare.value = ''
        this.$refs.responsiva.value = ''
      }
      this.dialogNewReq = false
      this.dialogDetReq = false
      this.dialogNewInc = false
      this.dialogDetInc = false
    },
    readFile(doc) {
      return new Promise(() => {
        let fr = new FileReader();
        let file = this.$refs[doc].files
        let name = file[0].name
        let size = file[0].size
        if (size <= 10000000) {
          fr.onload = () => {
            this.solicitud[doc].nombre = name
            this.solicitud[doc].data = fr.result
            this.color[doc] = 'success'
          }
          fr.onerror = () => {
            this.color[doc] = ''
            this.error = true
            this.msgError = 'El archivo no fue leído correctamente'
          }
          fr.readAsDataURL(file[0]);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (10 MB)'
        }
      });
    },
    readFileInc(doc) {
      return new Promise(() => {
        let fr = new FileReader();
        let file = this.$refs[doc].files
        let name = file[0].name
        let size = file[0].size
        if (size <= 10000000) {
          fr.onload = () => {
            this.solicitud.incremento[doc].nombre = name
            this.solicitud.incremento[doc].data = fr.result
            this.color[doc] = 'success'
          }
          fr.onerror = () => {
            this.error = true
            this.msgError = 'El archivo no fue leído correctamente'
          }
          fr.readAsDataURL(file[0]);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (10 MB)'
        }
      });
    },
    save() {
      this.questionReq = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.solicitud.pagare.data === null || this.solicitud.responsiva.data === null) {
          this.error = true
          this.msgError = 'Debe adjuntar ambos documentos'
        }
        else if (this.solicitud.pagare.data !== null &&
          (this.solicitud.pagare.nombre === '' || this.solicitud.pagare.nombre.length > 100)) {
          this.error = true
          this.msgError = 'El nombre del pagaré es incorrecto'
        }
        else if (this.solicitud.responsiva.data !== null &&
          (this.solicitud.responsiva.nombre === '' || this.solicitud.responsiva.nombre.length > 100)) {
          this.error = true
          this.msgError = 'El nombre de la carta responsiva es incorrecto'
        }
        else {
          this.loading = true
          let data = {
            area: this.solicitud.area,
            centro: this.solicitud.centro,
            importe: parseFloat(parseFloat(this.solicitud.importe).toFixed(2)),
            letra: this.solicitud.letra,
            detalle: this.solicitud.detalle,
            empresa: this.solicitud.empresa,
            observaciones: this.solicitud.observaciones,
            pagare_nombre: this.solicitud.pagare.nombre,
            pagare_data: this.solicitud.pagare.data,
            responsiva_nombre: this.solicitud.responsiva.nombre,
            responsiva_data: this.solicitud.responsiva.data
          }
          this.ws('post', 'nuevaSolicitudCajaChica', data)
            .then(res => {
              if (res.ok) {
                this.close()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    },
    prepareDetailForm(data) {
      this.idElementoSeleccionado = this.caja_chica
      this.detalle.nombre = data.detalle_usuario.nombre + ' ' + data.detalle_usuario.apellido_paterno + ' ' +
        data.detalle_usuario.apellido_materno
      this.detalle.nombre = this.detalle.nombre.trim();
      this.detalle.puesto = data.detalle_usuario.puesto
      this.detalle.departamento = data.detalle_usuario.departamento
      this.detalle.oficina = data.detalle_usuario.ubicacion
      this.detalle.estado = data.solicitud.estado
      this.detalle.area = data.solicitud.area
      this.detalle.centro = data.solicitud.centro
      this.detalle.importe = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.letra = data.solicitud.letra
      this.detalle.detalle = data.solicitud.detalle
      this.detalle.empresa = data.solicitud.empresa
      this.detalle.observaciones = data.solicitud.observaciones
      this.detalle.pagare.nombre = data.solicitud.pagare.nombre
      this.detalle.pagare.data = data.solicitud.pagare.data
      this.detalle.responsiva.nombre = data.solicitud.responsiva.nombre
      this.detalle.responsiva.data = data.solicitud.responsiva.data
      this.detalle.firmas = data.firmas
      this.dialogDetReq = true
    },
    downloadData(doc) {
      let nombre = this.detalle[doc].nombre
      let data = this.detalle[doc].data
      if (data !== null && data !== '') {
        let mimetype = data.split(';')[0].split(':')[1]
        download(data, nombre, mimetype)
      }
      else {
        this.error = true
        this.msgError = 'El documento no se encuentra disponible'
      }
    },
    downloadDataInc(doc) {
      let nombre = this.detalle.incremento[doc].nombre
      let data = this.detalle.incremento[doc].data
      if (data !== null && data !== '') {
        let mimetype = data.split(';')[0].split(':')[1]
        download(data, nombre, mimetype)
      }
      else {
        this.error = true
        this.msgError = 'El documento no se encuentra disponible'
      }
    },
    prepareDetailInc(id, data) {
      this.detalle.incremento.id = id
      this.detalle.incremento.estado = data.incremento.estado
      this.detalle.incremento.importe = data.incremento.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.incremento.letra = data.incremento.letra
      this.detalle.incremento.observaciones = data.incremento.observaciones
      this.detalle.incremento.pagare.nombre = data.incremento.pagare.nombre
      this.detalle.incremento.pagare.data = data.incremento.pagare.data
      this.detalle.incremento.responsiva.nombre = data.incremento.responsiva.nombre
      this.detalle.incremento.responsiva.data = data.incremento.responsiva.data
      this.detalle.incremento.firmas = data.firmas
      this.dialogDetInc = true
    },
    showDetailInc(id) {
      if (id !== null) {
        this.loading = true
        this.ws('get', 'detalleIncrementoCajaChica', { id })
          .then(res => {
            if (res.ok) {
              this.prepareDetailInc(id, res.data)
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    detailRequest() {
      let id = this.caja_chica
      if (id) {
        this.loading = true
        this.ws('get', 'detalleSolicitudCajaChica', { id })
          .then(res => {
            if (res.ok) {
              this.prepareDetailForm(res.data)
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar una caja chica'
      }
    },
    newIncrease() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.solicitud.incremento.pagare.data === null || this.solicitud.incremento.responsiva.data === null) {
          this.error = true
          this.msgError = 'Debe adjuntar ambos documentos'
        }
        else if (this.solicitud.incremento.pagare.data !== null &&
          (this.solicitud.incremento.pagare.nombre === '' || this.solicitud.incremento.pagare.nombre.length > 100)) {
          this.error = true
          this.msgError = 'El nombre del pagaré es incorrecto'
        }
        else if (this.solicitud.incremento.responsiva.data !== null &&
          (this.solicitud.incremento.responsiva.nombre === '' || this.solicitud.incremento.responsiva.nombre.length > 100)) {
          this.error = true
          this.msgError = 'El nombre de la carta responsiva es incorrecto'
        }
        else {
          this.loading = true
          let data = {
            id: this.caja_chica,
            importe: parseFloat(parseFloat(this.solicitud.importe).toFixed(2)),
            letra: this.solicitud.letra,
            observaciones: this.solicitud.observaciones,
            pagare: {
              nombre: this.solicitud.incremento.pagare.nombre,
              data: this.solicitud.incremento.pagare.data
            },
            responsiva: {
              nombre: this.solicitud.incremento.responsiva.nombre,
              data: this.solicitud.incremento.responsiva.data
            }
          }
          this.ws('post', 'nuevoIncrementoCajaChica', data)
            .then(res => {
              if (res.ok) {
                this.close()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    },
    cancelRequest() {
      this.questionCan = false
      this.loading = true
      this.ws('post', 'cancelarSolicitudCajaChica')
        .then(res => {
          if (res.ok) {
            this.moves = []
            this.total = null
            this.close()
            this.refresh()
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    print() {
      this.loading = true
      let data = {
        idElementoSeleccionado: this.idElementoSeleccionado
      }
      this.ws('get', 'impresionDetalleCajaChica', data)
        .then(res => {
          if (res.ok) {
            this.close()
            this.refresh()
            this.success = true
            this.msgSuccess = res.message
            window.open(res.data, '_blank');
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
